import { render, staticRenderFns } from "./VRBrainTraining.vue?vue&type=template&id=644ab118&"
import script from "./VRBrainTraining.vue?vue&type=script&lang=js&"
export * from "./VRBrainTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports